import logo from './logo.svg';
import './App.css';
import Routes from './routing';

function App() {
  return (
    <> 
       <Routes />
    </>
   
  );
}

export default App;
